import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = { class: "title-wrapper" }
const _hoisted_3 = { class: "default-count" }
const _hoisted_4 = { class: "filters" }
const _hoisted_5 = { class: "dropdown-button" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "spinner"
}
const _hoisted_8 = {
  key: 1,
  class: "empty-block--wrapper"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 2,
  class: "table-wrapper scroll-wrapper"
}
const _hoisted_11 = { class: "table-default" }
const _hoisted_12 = { class: "listing-title bold" }
const _hoisted_13 = { class: "text-site" }
const _hoisted_14 = { class: "menu-wrapper" }
const _hoisted_15 = { class: "wrapper-dots" }
const _hoisted_16 = { class: "menu-option" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { class: "title-row" }, [
        _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "title-main" }, "Listings", -1)),
        _createElementVNode("div", { class: "title-controls" }, [
          _createElementVNode("button", {
            class: "button primary new-btn",
            onClick: $setup.openCreateListing
          }, "Create Listing"),
          _createElementVNode("button", {
            class: "button primary configure",
            onClick: $setup.openConfigureModal
          }, "Configure")
        ])
      ]),
      _createElementVNode("div", _hoisted_3, _toDisplayString($setup.plural($setup.listingList.length, "Listing")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode($setup["DropDown"], null, {
        control: _withCtx(() => [
          _createElementVNode("button", _hoisted_5, _toDisplayString($setup.activeFilter.label), 1)
        ]),
        dropdown: _withCtx(() => [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filters, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.value,
                onClick: ($event: any) => ($setup.selectFilter(item)),
                class: _normalizeClass({ 'dropdown__item-active': $setup.activeFilter.label === item.label })
              }, _toDisplayString(item.label), 11, _hoisted_6))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7))
      : ($setup.listingList.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("img", {
              class: "empty-block--icon",
              src: require('@/assets/icons/icon-listing-slim.svg')
            }, null, 8, _hoisted_9),
            _cache[3] || (_cache[3] = _createElementVNode("p", null, "Your listings will appear here", -1))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("table", _hoisted_11, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.titles, (item, index) => {
                    return _createElementVNode("th", { key: index }, _toDisplayString(item.text), 1)
                  }), 64)),
                  _cache[4] || (_cache[4] = _createElementVNode("th", null, null, -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.listingList, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_12, _toDisplayString(item.title), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(item.listingSite), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["badge", $setup.getListingStatusClass(item.status)])
                      }, _toDisplayString(item.status), 3)
                    ]),
                    _createElementVNode("td", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode($setup["DropDown"], null, {
                          control: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("div", { class: "dots" }, [
                              _createElementVNode("div", { class: "actions" })
                            ], -1)
                          ]))]),
                          dropdown: _withCtx(() => [
                            _createElementVNode("ul", _hoisted_16, [
                              (item.status !== $setup.ListingStatus.DRAFT)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 0,
                                    onClick: ($event: any) => ($setup.editListing(item.id))
                                  }, "Edit/View", 8, _hoisted_17))
                                : _createCommentVNode("", true),
                              (item.status !== $setup.ListingStatus.SOLD)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 1,
                                    onClick: ($event: any) => ($setup.handleAction(item.status, item.id))
                                  }, _toDisplayString($setup.actionText(item.status)), 9, _hoisted_18))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])),
    _createVNode($setup["ConfigureAgentIdModal"], {
      "is-open": $setup.isOpenedConfigureModal,
      onClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.isOpenedConfigureModal = false)),
      onSaveAgentId: _cache[1] || (_cache[1] = ($event: any) => ($setup.saveAgentId($event)))
    }, null, 8, ["is-open"])
  ]))
}